export default API => ({
  // 获取海报
  getPoster(data) {
    return API({
      url:  '/common-services/v1/poster/genPoster',
      method:'post',
      data,
    });
  },
  // 根据手机号获取企业合伙人信息
  findBranchIdByPhone(params){
    return API({
      url: '/usercenter/v1/branchApplyRecord/findChannelBranchIdByPhone',
      method:'get',
      params
    })
  },
  // 获取活动时间
  findActivityTime() {
    return API({
      url: '/hrss-platform-marketing/v1/open/activity/findActivityTime',
      method:'get',
    })
  },
  // 获取秒杀商品
  findByCondition(data) {
    return API({
      url: '/hrss-platform-marketing/v1/seckill/findByCondition',
      method:'post',
      data,
    })
  },
  // 获取商品列表
  channelGoodsList(data,params) {
    return API({
      url: '/order/v1/saleSystem/distributionGoods/mall/channelGoodsList',
      method:'post',
      data,
      params
    })
  },
  // 获取推荐商品分类
  getGoodsCategory() {
    return API({
      url: '/hrss-platform-marketing/v1/open/activity/goodsIdArea',
      method:'get',
    })
  },
  // 拼团商品
  findGroupGoodsList(params) {
    return API({
      url: '/hrss-platform-marketing/v1/activityRuleItem/findGroupGoodsList',
      method:'get',
      params
    })
  },
  // 拼团详情
  findOrderGroupByGroupId(params) {
    return API({
      url: '/order/v1/open/order/findOrderGroupByGroupId',
      method:'get',
      params
    })
  },
  // 根据branchId 获取域名
  saasBranchDomain(params) {
    return API({
      url: '/modular/admin/v1/frontend/getdomainsByBranchId',
      method:'get',
      params
    })
  },
  // 获取推荐列表
  getRecommendGood(data,params) {
    return API({
      url: '/hrss-platform-marketing/v1/open/activity/channelGoodsListByIds',
      method:'post',
      data,
      params
    })
  },
})
